/**
 * Macboot Cart.js Dedup Cache
 * 
 * Problem: 5+ scripts (theme + t.js + trustvox + apps) call /cart.js 
 * simultaneously, each blocking ~400-1200ms.
 * 
 * Solution: Intercept fetch() and XHR for /cart.js, dedupe parallel
 * requests, and cache result for 2s to allow scripts to share it.
 */
(function() {
  'use strict';
  
  if (window.__macbootCartCacheLoaded) return;
  window.__macbootCartCacheLoaded = true;
  
  var CACHE_TTL_MS = 2000;
  var cachedResponse = null;
  var cachedAt = 0;
  var inflightPromise = null;
  
  function isCartJsUrl(url) {
    if (!url) return false;
    var s = url.toString();
    return s.endsWith('/cart.js') || s.includes('/cart.js?') || /\/cart\.js(\?|$)/.test(s);
  }
  
  function isFresh() {
    return cachedResponse && (Date.now() - cachedAt) < CACHE_TTL_MS;
  }
  
  // Intercept fetch
  var origFetch = window.fetch;
  if (origFetch) {
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url);
      var method = (init && init.method) || (input && input.method) || 'GET';
      
      if (isCartJsUrl(url) && method.toUpperCase() === 'GET') {
        // Return cached if fresh
        if (isFresh()) {
          return Promise.resolve(cachedResponse.clone());
        }
        // Dedup parallel requests
        if (inflightPromise) {
          return inflightPromise.then(r => r.clone());
        }
        inflightPromise = origFetch.apply(this, arguments).then(r => {
          cachedResponse = r.clone();
          cachedAt = Date.now();
          inflightPromise = null;
          return r;
        }).catch(e => {
          inflightPromise = null;
          throw e;
        });
        return inflightPromise.then(r => r.clone());
      }
      
      // Invalidate cache on non-GET cart operations
      if (url && /\/cart\/(add|update|change|clear)/.test(url.toString())) {
        cachedResponse = null;
        cachedAt = 0;
      }
      
      return origFetch.apply(this, arguments);
    };
  }
  
  // Intercept XHR (some scripts use XMLHttpRequest)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function(method, url) {
    this.__macbootUrl = url;
    this.__macbootMethod = method;
    return origOpen.apply(this, arguments);
  };
  
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function() {
    var xhr = this;
    if (isCartJsUrl(xhr.__macbootUrl) && (xhr.__macbootMethod || '').toUpperCase() === 'GET' && isFresh()) {
      // Synthesize response from cache
      cachedResponse.clone().text().then(text => {
        Object.defineProperty(xhr, 'readyState', { value: 4, writable: false });
        Object.defineProperty(xhr, 'status', { value: 200, writable: false });
        Object.defineProperty(xhr, 'responseText', { value: text, writable: false });
        Object.defineProperty(xhr, 'response', { value: text, writable: false });
        if (xhr.onload) xhr.onload();
        if (xhr.onreadystatechange) xhr.onreadystatechange();
      });
      return;
    }
    return origSend.apply(this, arguments);
  };
})();
